/* @flow */
import React from 'react';
import ReactDropzone from 'react-dropzone';
import _cx from 'classnames/bind';
import styled from 'styled-components';
import s from './Dropzone.styl';
const cx = _cx.bind(s);
import { Pulse } from './Spinner.js';

type DefaultChildrenProps = {
  disabled?: boolean,
  message: string,
  acceptedFileFormatMessage: string,
};

const DefaultChildren = ({ disabled, message, acceptedFileFormatMessage }: DefaultChildrenProps) => (
  <div className={cx('default')}>
    {disabled ? <Pulse /> : (
      <div>
        <i className='fa fa-cloud-upload'></i>
        <h2>{message}</h2>
        <h5>{acceptedFileFormatMessage}</h5>
      </div>
    )}
  </div>
);

const StyledDropzone = styled.div`
&& {  
    background: transparent;
}
`;

/**
 * @module Dropzone
 *
 * Use children to add custom markup to the center of the drop area.
 */
export type DropzoneProps = {
  onDrop?: (files: File[], rejectedFiles: File[], e: ?Event) => void,
  onDropAccepted?: (files: File[], e: Event) => void,
  onDropRejected?: (rejectedFiles: File[], e: Event) => void,
  className?: string,
  children?: any,
  maxSize?: number, // In bytes
  activeClassName?: string,
  disabled?: boolean,
  message: string,
  acceptedFileFormatMessage: string,
};
export class Dropzone extends React.Component {
  props: DropzoneProps;

  static defaultProps = {
    size: 150,
    multiple: false,
    activeClassName: s.active,
    disabled: false,
    message: 'Drag & Drop File or Click to Upload File',
    acceptedFileFormatMessage: 'text/*,.csv,.pdf',
  };

  /**
   * Note: The .dropzone class is necessary for styling .active state. Passing
   * an empty object to the s prop prevents default inline styling
   */
  render() {
    const { className, children, disabled, message, acceptedFileFormatMessage, ...props } = this.props;
    return (
      <StyledDropzone
        className={cx('Dropzone', className, { disabled })}
        data-nightwatch='Upload'>
        <ReactDropzone
          className={'dropzone ' + cx('dropzone')}
          disablePreview={true}
          {...props}
        />
        <div className={cx('center')}>
          {children || <DefaultChildren message={message} disabled={disabled} acceptedFileFormatMessage={acceptedFileFormatMessage} />}
        </div>
      </StyledDropzone>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/Dropzone.js